// removed by extract-text-webpack-plugin
module.exports = {"next":"NextSliderButton_next--3JLkw","isDisabled":"NextSliderButton_isDisabled--2YaJT"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/NextSliderButton/NextSliderButton.scss
// module id = 2295
// module chunks = 11